import { Card, Spinner } from "components/common"
import { IconText } from "components/custom"
import cx from "clsx"
import theme from "utils/themeVars"
import styles from "./InfoTable.module.less"

const InfoTable = ({
  className = "",
  headerTitle,
  headerIcon = "BiCoinStack",
  actionLabel,
  onAction,
  actionLoading = false,
  tableData = [],
  Shadow = false,
  bordered = false,
}) => {
  const hasAction = actionLabel && onAction

  return (
    <Card Shadow={Shadow} bordered={bordered} className={cx(styles.infoTableCard, "w-100", className)}>
      {headerTitle && (
        <div className={styles.infoTableHeader}>
          <IconText
            className="semiBold"
            icon={headerIcon}
            iconProps={{ color: theme["primary-color"] }}
            title={headerTitle}
            titleProps={{ style: { fontSize: "16px" } }}
            style={{ lineHeight: "normal" }}
          />
          {hasAction && !actionLoading && (
            <div className={styles.infoTableAction} onClick={onAction}>
              {actionLabel}
            </div>
          )}
          {hasAction && actionLoading && (
            <div className={styles.infoTableAction}>
              <Spinner size="small"/>
            </div>
          )}
        </div>
      )}

      <table className={styles.infoTable}>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td className={styles.infoTableLabel}>{row.label}</td>
              <td className={styles.infoTableValue}>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  )
}

export default InfoTable
